import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { authFetch } from '../../../utils/authFetch';

export const fetchFindings = createAsyncThunk(
  'agencyFindings/fetchAll',
  async ({ assessmentId, severity, status, finding_type }, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams({ assessmentId });
      if (severity) params.set('severity', severity);
      if (status) params.set('status', status);
      if (finding_type) params.set('finding_type', finding_type);
      const response = await authFetch(`/.netlify/functions/agency-findings-list?${params}`, { method: 'GET' });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        return rejectWithValue(err.error || `HTTP ${response.status}`);
      }
      return await response.json();
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const updateFinding = createAsyncThunk(
  'agencyFindings/update',
  async (data, { rejectWithValue }) => {
    try {
      const response = await authFetch('/.netlify/functions/agency-findings-update', {
        method: 'POST',
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        return rejectWithValue(err.error || `HTTP ${response.status}`);
      }
      return await response.json();
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const agencyFindingsSlice = createSlice({
  name: 'agencyFindings',
  initialState: {
    items: [],
    loading: false,
    saving: false,
    error: null,
  },
  reducers: {
    clearFindingsError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFindings.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchFindings.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.findings || [];
      })
      .addCase(fetchFindings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch findings';
      })
      .addCase(updateFinding.pending, (state) => { state.saving = true; })
      .addCase(updateFinding.fulfilled, (state, action) => {
        state.saving = false;
        const updated = action.payload.finding;
        if (updated) {
          const idx = state.items.findIndex(f => f.id === updated.id);
          if (idx >= 0) state.items[idx] = updated;
        }
      })
      .addCase(updateFinding.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload || 'Failed to update finding';
      });
  },
});

export const { clearFindingsError } = agencyFindingsSlice.actions;
export const selectFindings = (state) => state.agencyFindings?.items || [];
export const selectFindingsLoading = (state) => state.agencyFindings?.loading || false;
export default agencyFindingsSlice.reducer;
